import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  styled,
  useToast
} from "@chakra-ui/react";
import {useTranslation} from "react-i18next";
import Rank from "../../../models/rank";
import React, {useEffect, useState} from "react";
import InputIcon from "../../global/input/InputIcon";
import {BiRename} from "react-icons/bi";
import RankServices from "../../../services/RankServices";
import DrawerFooterGeneric from "../DrawerFooterGeneric";

const CustomDrawerHeader = styled(DrawerHeader, {
  baseStyle: {
    display: "flex",
    fontSize: "24px",
    fontWeight: "light",
    color: "#2D2D2D",
    fontFamily: "Mabry Pro",
  }
})

const CustomDrawerBody = styled(DrawerBody, {
  baseStyle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "20px",
    width: "100%",
  }
})

interface RankCreateDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  ranks: Rank[];
  setRanks: (ranks: Rank[]) => void;
}

function RankCreateDrawer({
                            isOpen,
                            onClose,
                            ranks,
                            setRanks,
                          }: RankCreateDrawerProps) {

  const {t} = useTranslation();
  const toast = useToast();

  const [newRank, setNewRank] = useState<Rank>(new Rank());
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setNewRank(new Rank())
  }, [isOpen]);

  const handleCreateRank = () => {
    if (!newRank.name) {
      toast({
        title: t("labels.error"),
        description: t("pages.my_company.ranks.create.error_empty_name"),
        status: "error",
        duration: 4500,
      })
      return;
    }
    setLoading(true)
    RankServices.create(newRank)
      .then((rank) => {
        setRanks([...ranks, rank].sort((a, b) => a.name.localeCompare(b.name)))
        setLoading(false)
        toast({
          title: t("pages.my_company.ranks.create.success"),
          status: "success",
          duration: 4500,
          isClosable: true,
        })
        onClose()
      })
      .catch(
        (error) => {
          toast({
            title: t("labels.error"),
            description: t(`pages.my_company.ranks.create.${error.detail}`),
            status: "error",
            duration: 4500,
          })
        }
      ).finally(() => {
      setLoading(false)
    });
  }

  return (
    <Drawer
      isOpen={isOpen}
      placement='right'
      onClose={onClose}
      size="lg"
    >
      <DrawerOverlay/>
      <DrawerContent>
        <DrawerCloseButton/>
        <CustomDrawerHeader>
          {t("pages.my_company.ranks.create.title")}
        </CustomDrawerHeader>

        <CustomDrawerBody paddingTop={"30px"}>

          <InputIcon
            icon={<BiRename color="#918D86"/>}
            placeholder={t("labels.name") as string}
            value={newRank.name as string}
            onChange={(e) => setNewRank({...newRank, name: e.target.value} as Rank)}
            type="text"
          />

          <InputIcon
            icon={<BiRename color="#918D86"/>}
            placeholder={t("labels.description") as string}
            value={newRank.description as string}
            onChange={(e) => setNewRank({...newRank, description: e.target.value} as Rank)}
            type="textArea"
          />

        </CustomDrawerBody>

        <DrawerFooterGeneric onClose={onClose}
                             onSave={() => handleCreateRank()}
                             loading={loading}/>


      </DrawerContent>
    </Drawer>
  )
}

export default RankCreateDrawer;